import { memo, useEffect, useState } from 'react';

import { UsergroupDeleteOutlined } from '@ant-design/icons';
import { t } from '../../languages';
import { recordPageGA } from '../../modules/ga';

import plan from '../../data/plan';
import DeleteButtonWithConfirm from '../Utils/DeleteButtonWithConfirm';
import { AGE } from '../../modules/user';
import { Avatar, Button } from 'antd';
import { getColorFromName } from '../../utils';
import { disconnectSocket, emitJoinRoom, initSocket, joinRoom } from '../../modules/websocket';

const getUnits = (currentPlan) => {
    if (currentPlan) {
        const levelsUnitsMap = {};
        currentPlan.forEach((level) => {
            const units = level.units;
            units.forEach((unit) => {
                levelsUnitsMap[`u${unit.uid}`] = { label: unit.label, level: level.level };
            });
        });

        return levelsUnitsMap;
    } else {
        return [];
    }
}

let intervalId = null;
const LOADINTERVAL = 10000; // 10 seconds
const NUMMAXSTUDENTS = 35;

const ClassDetails = ({ lang, theClass, loadAClass, onDelete }) => {
    const [levelsUnitsMap, setLevelsUnitsMap] = useState(null);

    // Registro en Google Analytics
    useEffect(() => {
        recordPageGA('/class-details');

        return () => {
            disconnectSocket();
            if (intervalId) {
                clearInterval(intervalId);
            }
        };

    }, []);

    useEffect(() => {
        if (theClass) {
            const age = theClass ? theClass.age : 1;
            const newPlan = JSON.parse(JSON.stringify(plan[age]));
            setLevelsUnitsMap(getUnits(newPlan));

            /* intervalId = setInterval(() => {
                loadAClass(theClass.id);
            }, LOADINTERVAL); // Carga cada 10 segundos */
            // emitJoinRoom(`class-${theClass.id}`);
            joinRoom(`class-${theClass.id}`);
        }
    }, [theClass]);


    if (theClass) {
        const students = theClass ? theClass.students : null;
        const studentsStatus = theClass ? theClass.studentsStatus : null;

        // console.log('ClassDetails. students:', students);

        return (
            <section className="class-details">
                <div className="create-class-code">
                    <h3>{t(lang, 'classcode')}:</h3>
                    <h2 className='code'>{theClass.code}</h2>
                    <br />
                    <p>
                        {t(lang, 'inviteStudents')} <button className="fake-button button-yellow">{t(lang, 'joinClass')}</button> {t(lang, 'onthe')}  <span>App MiSoroban</span> {t(lang, 'orInApp')} <span>app.misoroban.com</span>.
                    </p>

                </div>

                <div className="students-list">
                    <p><strong>{t(lang, 'classLevel')}</strong>: <Avatar src={`./static/ages/age_${theClass.age}.svg`} /> {AGE[theClass.age]}</p>
                    <h3>{t(lang, 'students')}</h3>

                    <p><UsergroupDeleteOutlined /> {students ? students.length : 0} {t(lang, 'students')}</p>

                    {students && students.length ? <ul className="student-items">
                        {students.map((student, idx) => {
                            const status = studentsStatus ? studentsStatus[student.uid] : null;

                            const currentUnit = status && levelsUnitsMap ? status.current : null;
                            const currentUnitLabel = levelsUnitsMap && currentUnit ? levelsUnitsMap[currentUnit].label : t(lang, 'N/A');
                            // console.log('ClassDetails currentUnitLabel:', currentUnitLabel);

                            return (
                                <li key={`${student.uid}-${idx}`} className="student-item">
                                    <div
                                        className="student-avatar"
                                        style={{ backgroundColor: getColorFromName(idx) }}
                                    >
                                        {student.avatar ? <img src={`./static/avatar/${student.avatar}.jpg`} alt="" /> : student.name.charAt(0).toUpperCase()}
                                    </div>
                                    <div className="student-info">
                                        <strong>{student.name}</strong>
                                        <span>{t(lang, 'advance')}: {t(lang, currentUnitLabel)}</span>
                                    </div>
                                </li>
                            );
                        })}
                    </ul> : null}
                    <h5 className='max-students'>ⓘ {t(lang, 'maxNStudents')}: {NUMMAXSTUDENTS}</h5>
                </div>

                <br />
                <br />

                <DeleteButtonWithConfirm
                    lang={lang}
                    text={'deleteClass'}
                    message={'deleteclasswilleliminatestudentsaccess'}
                    onDelete={() => {
                        // console.log('Acción de borrar ejecutada');
                        onDelete(theClass.teacher, theClass.id);
                    }}
                />
            </section>
        );
    } else return null;
};

export default memo(ClassDetails);